<template>
  <div>
    <vue-headful title="Mijn profiel" />
    <Header page_title="Mijn profiel" />
    <div id="profile" class="sd-profile">
      <div class="container-fluid pt-5 text-center">
        <div class="avatar profile rounded-circle position-relative overflow-hidden my-2 mx-auto">
          <span
            v-if="user.avatar"
            class="d-block image_background"
            :style="this.ImageBackground(user.avatar)"
          ></span>
          <svg-icon v-else-if="user.sub_branch === '2'" icon="school_vo" class=""/>
          <svg-icon v-else-if="user.branch === 3" icon="healthcare" class=""/>
          <svg-icon v-else icon="education" class=""/>
        </div>
        <strong class="sd-title bold small">{{ user.name }}</strong>
      </div>
      <svg-icon icon="wave" class="seperator" />
      <div class="profile-information">
        <div class="container-fluid pb-5">
          <h2 class="sd-title mini py-4"><span class="title-text"><svg-icon icon="suitcase" />Informatie over de organisatie</span></h2>
          <div class="sd-container small-radius bg-white information-container">
            <p v-if="user.about" class="br mb-0">{{ user.about }}</p>
            <span v-else class="required">Vertel hier iets over de organisatie om mensen een beter beeld van de school te geven.</span>
          </div>
          <router-link
            :to="{name: 'company-details', params: {action: 'save'}}"
            class="btn btn-warning btn-block"
            v-ripple="'rgba(255, 255, 255, 0.35)'"
          >
            Bijwerken
          </router-link>
        </div>
      </div>
      <Footer />
    </div>
  </div>
</template>

<script>
export default {
  data: function() {
    return {
      user: ""
    };
  },
  async created() {},
  async mounted() {
    await this.fetchData();
  },
  watch: {
    $route: "fetchData"
  },
  methods: {
    async fetchData() {
      this.user = JSON.parse(localStorage.getItem("user"));
    }
  }
};
</script>

<style scoped>
/deep/.sd-profile .avatar .svg-container {
  padding: 10px;
}

/deep/.sd-profile .avatar .svg-container,
/deep/.sd-profile .avatar svg {
  width: 100%;
  height: 100%;
}

.seperator {
  display: block;
  width: 100%;
  color: #F6F6F6;
}

.sd-profile .profile-information {
  background-color: #F6F6F6;
  height: 100%;
}
</style>
